<template>
  <div class="row main-content">
    <div
      v-if="isProcessing"
      class="col text-center"
    >
      <img
        src="@/assets/img/loader.gif"
        class="mx-auto d-block center-block"
      >
    </div>
    <div
      v-else
      class="col"
    >
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('label.order.orderDetails') }}
      </h1>

      <div
        v-if="responseErr"
        class="alert alert-danger text-center border-0 shadow-sm rounded-0"
      >
        <strong>
          {{ $t('error.'+`${responseErr}`) }}
        </strong>
      </div>

      <div
        v-if="$store.state.orders.orderDetail && hasPermission('orders:write') && $store.state.orders.orderDetail.isRemindPin"
        class="card-body bg-light mb-4"
      >
        <BaseButton
          type="button"
          class="btn btn-default btn-white btn-export m-1"
          data-bs-toggle="modal"
          data-bs-target="#remindPinModal"
        >
          {{ $t('label.order.details.pinRepublication') }}
        </BaseButton>
      </div>

      <div v-if="$store.state.orders.orderDetail">
        <div
          id="accordionDetail"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingDetail"
            data-bs-toggle="collapse"
            href="#collapseDetail"
            aria-expanded="false"
            aria-controls="collapseDetail"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.card.detail.details') }}
          </div>

          <div
            id="collapseDetail"
            aria-labelledby="headingDetail"
            data-bs-parent="#accordionDetail"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.distributor') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.orders.orderDetail.distributorRef) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.funderContract') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.orders.orderDetail.funderContractRef) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.beneficiary') }}
              </div>
              <div class="col">
                <template v-if="$store.state.orders.orderDetail.beneficiaryServiceContext">
                  <div
                    role="button"
                    class="clickable-div"
                    @click="showBeneficiary($store.state.orders.orderDetail.beneficiaryServiceContext)"
                  >
                    {{ $filters.nullFilter($store.state.orders.orderDetail.beneficiaryServiceReference) }}
                  </div>
                </template>
                <template v-else>
                  {{ $filters.nullFilter($store.state.orders.orderDetail.beneficiaryServiceReference) }}
                </template>
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.product') }}
              </div>
              <div class="col">
                <template v-if="hasPermission('product:read') && $store.state.orders.orderDetail.productExternalReference ">
                  <div
                    role="button"
                    class="clickable-div"
                    @click="showProduct($store.state.orders.orderDetail.productExternalReference)"
                  >
                    {{ $filters.nullFilter($store.state.orders.orderDetail.productExternalReference) }}
                  </div>
                </template>
                <template v-else>
                  {{ $filters.nullFilter($store.state.orders.orderDetail.productExternalReference) }}
                </template>
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.orderType') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.orders.orderDetail.orderType) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.expeditionRef') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.orders.orderDetail.expeditionRef) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.orderStatus') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.orders.orderDetail.orderStatus) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.cardIdentifier') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.orders.orderDetail.cardId) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.PAN') }}
              </div>
              <div class="col">
                {{ $store.state.orders.orderDetail.panCard }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.expirationDate') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.orders.orderDetail.expiryDate) }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.order.details.sequenceNumber') }}
              </div>
              <div class="col">
                {{ $filters.nullFilter($store.state.orders.orderDetail.psnCard) }}
              </div>
            </div>

            <!--Start block -->
            <div v-if="$store.state.orders.orderDetail.cardOrderDetails">
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.cardVisualReference') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.artworkRef) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.manufacturer') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.cardProducer) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.sortCriteria') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.cardSortingCriteria) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.trackingDataList') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.trackingDataList) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.documentReference') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.documentRef) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.expeditionDate') }}
                </div>
                <div class="col">
                  {{ $filters.dateYYYYMMDDTiretsOrNull($store.state.orders.orderDetail.expeditionDate) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.orderReference') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.orderReference) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.mobilePhoneNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.cellPhoneNumber) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.customizationType') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.customization) }}
                </div>
              </div>

              <div
                style="margin-top:15px;margin-bottom:15px;"
                class="border-top"
              >
                <legend>{{ $t('label.order.details.deliveryAddress') }}</legend>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.line1') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressLine1) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.line2') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressLine2) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.line3') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressLine3) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.line4') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressLine4) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.line5') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressLine5) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.countryCode') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressCountryCode) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.landlinePhoneNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter( $store.state.orders.orderDetail.deliveryAddressPhoneNumber) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.city') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressTown) }}
                </div>
              </div>
              <div
                style="margin-bottom:15px;"
                class="row border-bottom"
              >
                <div class="col-2 text-end">
                  {{ $t('label.order.details.postalCode') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressZipCode) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.deliveryType') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryType) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.addresseeEmailPinCode') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.email) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.embossedNameOnCard') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.embossingName) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.extractionReference') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extractReference) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.orderHistory') }}
                </div>
                <div class="col">
                  <div v-if="$store.state.orders.orderDetail.ihmOrderStatusHistoriesNull">
                    --
                  </div>
                  <table
                    v-else
                    class="table table-hover table-sm table-striped border"
                  >
                    <thead>
                      <tr>
                        <th>{{ $t('label.order.details.orderStatus') }}</th>
                        <th>{{ $t('label.order.details.statusChangeDate') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="history in $store.state.orders.orderDetail.orderStatusHistories"
                        :key="history.id"
                        class="mb-3"
                      >
                        <td v-if="history.orderStatus == null">
                          --
                        </td>
                        <td v-else>
                          {{ translateStatus(history.orderStatus) }}
                        </td>
                        <td>{{ $filters.dateYYYYMMDDTirets(history.date) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.logoReference') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.logoRef) }}
                </div>
              </div>

              <!-- noDeliveryAddress -->
              <div v-if="$store.state.orders.orderDetail.noDeliveryAddress">
                <div
                  style="margin-top:15px;margin-bottom:15px;"
                  class="border-top"
                >
                  <legend>{{ $t('label.order.details.defaultDeliveryAddress') }}</legend>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line1') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressLine1) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line2') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressLine2) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line3') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressLine3) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line4') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressLine4) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line5') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressLine5) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.countryCode') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressCountryCode) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.landlinePhoneNumber') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressPhoneNumber) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.city') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressTown) }}
                  </div>
                </div>
                <div
                  style="margin-bottom:15px;"
                  class="row border-bottom"
                >
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.postalCode') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressZipCode) }}
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.fileNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.orderFileId) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.orderReason') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.orderReason) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.packageNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.packageNumber) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.packagingRef') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.packagingRef) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.customCardMessage') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.personalizedCardData) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.customizationElementsCardSlot') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.personalizedInsetData) }}
                </div>
              </div>

              <div v-if="$store.state.orders.orderDetail.extPersonalizedMsgData">
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.customedMessage') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.extPersonalizedMsgDataLine1) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end" />
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.extPersonalizedMsgDataLine2) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end" />
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.extPersonalizedMsgDataLine3) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end" />
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.extPersonalizedMsgDataLine4) }}
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.landlinePhoneNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.phoneNumber) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.manufacturingStatusHistory') }}
                </div>
                <div class="col">
                  <div v-if="$store.state.orders.orderDetail.extProducerStatusHistoryNull">
                    --
                  </div>
                  <table
                    v-else
                    class="table table-hover table-sm table-striped border"
                  >
                    <thead>
                      <tr>
                        <th>{{ $t('label.order.details.manufacturingStatus') }}</th>
                        <th>{{ $t('label.order.details.statusChangeDate') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="history in $store.state.orders.orderDetail.extProducerStatusHistoryList"
                        :key="history.id"
                        class="mb-3"
                      >
                        <td>{{ $filters.nullFilter(history.extProducerStatus ) }}</td>
                        <td>{{ $filters.dateYYYYMMDDTirets(history.date) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.manufacturingDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.productionDate) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.manufacturingOrderRef') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.productionRef) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.rejectDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.rejectionDate) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.packageSenderRef') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.senderRef) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.sendingType') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.sendingType) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.cardOrderSequenceNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.seqNbr) }}
                </div>
              </div>

            <!--End if block -->
            </div>

            <!-- Else, displaying Pin Mail Order Details -->
            <div v-else>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.expeditionDate') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.expeditionDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.orderReference') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderReference) }}
                </div>
              </div>
              <div
                v-for="extCdjExpeditionDocument in $store.state.orders.orderDetail.ExtCdjExpeditionDocumentList"
                :key="extCdjExpeditionDocument.id"
                class="row"
              >
                <div class="col-2 text-end">
                  {{ extCdjExpeditionDocument.externalReference }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter(extCdjExpeditionDocument.volume) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.mobilePhoneNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderCellPhoneNumber) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.customizationType') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderCustomization) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.customizationType') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderCustomization) }}
                </div>
              </div>
              <!-- Adresse de livraison -->
              <div
                style="margin-top:15px;margin-bottom:15px;"
                class="border-top"
              >
                <legend>{{ $t('label.order.details.deliveryAddress') }}</legend>
              </div>
              <div v-if="$store.state.orders.orderDetail.deliveryAddressNotNull">
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line1') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressLine1) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line2') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressLine2) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line3') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressLine3) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line4') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressLine4) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line5') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressLine5) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.countryCode') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressCountryCode) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.landlinePhoneNumber') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressPhoneNumber) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.city') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressTown) }}
                  </div>
                </div>
                <div
                  style="margin-bottom:15px;"
                  class="row border-bottom"
                >
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.postalCode') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.deliveryAddressZipCode) }}
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  style="margin-bottom:15px;"
                  class="row border-bottom"
                >
                  <div class="col-2 text-end" />
                  <div class="col">
                    {{ $t('label.order.details.noAddress') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.deliveryType') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderDeliveryType) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.email') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderEmail) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.extractionReference') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderExtractReference) }}
                </div>
              </div>
              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.orderHistory') }}
                </div>
                <div class="col">
                  <div v-if="$store.state.orders.orderDetail.ihmOrderStatusHistoriesNull">
                    --
                  </div>
                  <table
                    v-else
                    class="table table-hover table-sm table-striped border"
                  >
                    <thead>
                      <tr>
                        <th>{{ $t('label.order.details.orderStatus') }}</th>
                        <th>{{ $t('label.order.details.date') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="history in $store.state.orders.orderDetail.orderStatusHistories"
                        :key="history.id"
                        class="mb-3"
                      >
                        <td v-if="history.orderStatus == null">
                          --
                        </td>
                        <td v-else>
                          {{ translateStatus(history.orderStatus) }}
                        </td>
                        <td>{{ $filters.dateYYYYMMDDTirets(history.date) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- noDeliveryAddress -->
              <div v-if="$store.state.orders.orderDetail.noDeliveryAddress">
                <div
                  style="margin-top:15px;margin-bottom:15px;"
                  class="border-top"
                >
                  <legend>{{ $t('label.order.details.defaultDeliveryAddress') }}</legend>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line1') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressLine1) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line2') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressLine2) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line3') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressLine3) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line4') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressLine4) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.line5') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressLine5) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.countryCode') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressCountryCode) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.landlinePhoneNumber') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressPhoneNumber) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.city') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressTown) }}
                  </div>
                </div>
                <div
                  style="margin-bottom:15px;"
                  class="row border-bottom"
                >
                  <div class="col-2 text-end">
                    {{ $t('label.order.details.postalCode') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter($store.state.orders.orderDetail.noDeliveryAddressZipCode) }}
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.fileNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderFileId) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.orderReason') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderReason) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.orderReference') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderReference) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.packageNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderPackageNumber) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.pinCodePublisher') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderPinMailerEditor) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.pinSendingType') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderPinSendingType) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.landlinePhoneNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderPhoneNumber) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.manufacturingStatusHistory') }}
                </div>
                <div class="col">
                  <div v-if="$store.state.orders.orderDetail.extProducerStatusHistoryNull">
                    --
                  </div>
                  <table
                    v-else
                    class="table table-hover table-sm table-striped border"
                  >
                    <thead>
                      <tr>
                        <th>{{ $t('label.order.details.manufacturingStatus') }}</th>
                        <th>{{ $t('label.order.details.date') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="history in $store.state.orders.orderDetail.extProducerStatusHistoryList"
                        :key="history.id"
                        class="mb-3"
                      >
                        <td>{{ $filters.nullFilter(history.extProducerStatus) }}</td>
                        <td>{{ $filters.dateYYYYMMDDTirets(history.date) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.packageSenderRef') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderSenderRef) }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.order.details.cardOrderSequenceNumber') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.orders.orderDetail.extPinMailerOrderSeqNbr) }}
                </div>
              </div>

            <!--End else block -->
            </div>
          </div>
        </div>

        <div
          id="accordionCompte"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingCompte"
            data-bs-toggle="collapse"
            href="#collapseCompte"
            aria-expanded="false"
            aria-controls="collapseCompte"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.card.detail.account') }}
          </div>

          <div
            id="collapseCompte"
            aria-labelledby="headingCompte"
            data-bs-parent="#accordionCompte"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.account') }}
              </div>
              <div class="col">
                <strong>
                  <div
                    role="button"
                    class="clickable-div"
                    @click="showAccount($store.state.orders.orderDetail.accountDetailsPageContext)"
                  >
                    {{ $t('label.order.details.beneficiaryAccount') }}
                  </div>
                </strong>
              </div>
            </div>

            <div
              v-if="!$store.state.orders.orderDetail.singleFunderAccount"
              class="row"
            >
              <div class="col-2 text-end">
                {{ $t('label.card.detail.balance') }}
              </div>
              <div class="col">
                {{ $store.state.orders.orderDetail.accountBalance }}
              </div>
            </div>

            <div class="row">
              <div class="col-2 text-end">
                {{ $t('label.card.detail.available') }}
              </div>
              <div class="col">
                {{ $store.state.orders.orderDetail.accountAvailable }}
              </div>
            </div>
          </div>
        </div>

        <div
          id="accordionCartes"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingCartes"
            data-bs-toggle="collapse"
            href="#collapseCartes"
            aria-expanded="false"
            aria-controls="collapseCartes"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.card.detail.cards.cards') }}
          </div>

          <div
            id="collapseCartes"
            aria-labelledby="headingCartes"
            data-bs-parent="#accordionCartes"
            class="card-body collapse"
          >
            <div v-if="$store.state.orders.orderDetail.cards">
              <div
                v-for="opcCard in $store.state.orders.orderDetail.cards"
                :key="opcCard.id"
                class="border-top"
              >
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.card.detail.cards.cardId') }}
                  </div>
                  <div class="col">
                    <strong>
                      <div
                        role="button"
                        class="clickable-div"
                        @click="showCard(opcCard)"
                      >
                        {{ opcCard.cardId }}
                      </div>
                    </strong>
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.card.detail.cards.cardStatus') }}
                  </div>
                  <div class="col">
                    {{ $filters.nullFilter(opcCard.cardStatus) }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.card.detail.cards.panCard') }}
                  </div>
                  <div class="col">
                    {{ opcCard.panCard }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.card.detail.cards.psnCard') }}
                  </div>
                  <div class="col">
                    {{ opcCard.psnCard }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-2 text-end">
                    {{ $t('label.card.detail.cards.expiryDate') }}
                  </div>
                  <div class="col">
                    {{ opcCard.expiryDate }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="col"
            >
              --
            </div>
          </div>
        </div>

        <div
          id="accordionCommandes"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingCommandes"
            data-bs-toggle="collapse"
            href="#collapseCommandes"
            aria-expanded="false"
            aria-controls="collapseCommandes"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.card.detail.orders.commands') }}
          </div>

          <div
            id="collapseCommandes"
            aria-labelledby="headingCommandes"
            data-bs-parent="#accordionCommandes"
            class="card-body collapse"
          >
            <div
              v-for="opcOrder in $store.state.orders.orderDetail.orders"
              :key="opcOrder.id"
              class="border-top"
            >
              <div class="row">
                <div class="col-2 text-end">
                  {{ opcOrder.orderType }}
                </div>
                <div class="col">
                  <strong>
                    <div
                      role="button"
                      class="clickable-div"
                      @click="showOrder(opcOrder)"
                    >
                      n° {{ opcOrder.orderId }}
                    </div>
                  </strong>
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.card.detail.orders.expeditionRef') }}
                </div>
                <div class="col">
                  {{ opcOrder.expeditionRef }}
                </div>
              </div>

              <div class="row">
                <div class="col-2 text-end">
                  {{ $t('label.card.detail.orders.orderStatus') }}
                </div>
                <div class="col">
                  {{ opcOrder.orderStatus }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The Modal -->
    <div
      id="myModal"
      class="modal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">
              Modal Heading
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            />
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            Modal body..
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              data-bs-dismiss="modal"
            >
              {{ $t('label.order.close') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- remindPinModal -->
    <div
      id="remindPinModal"
      class="modal fade"
    >
      <div class="modal-dialog modal-lg">
        <form class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">
              {{ $t('label.order.details.cardPinRepublication') }}
            </h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            />
          </div>
          <div class="modal-body">
            <div
              v-if="isModalProcessing"
              class="text-center"
            >
              <img
                src="@/assets/img/loader.gif"
                class="center-block"
              >
            </div>
            <div v-else>
              <div
                v-if="modalError"
                class="col "
              >
                <div
                  class="alert alert-danger text-center border-0 shadow-sm rounded-0"
                >
                  {{ $t('error.'+`${modalResponseErr}`) }}
                </div>
              </div>
              <div class="col ">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.sendingMode') }}
                </label>
                <select
                  v-model="criterias.pinSendingMode"
                  :class="status(v$.criterias.pinSendingMode)"
                  name="pinSendingMode"
                  class="form-control rounded-0 form-select"
                >
                  <option
                    v-for="type in pinSendingModeNum"
                    :key="type.id"
                    :value="type"
                  >
                    {{ type }}
                  </option>
                </select>
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinSendingMode.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col ">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.fileNumber') }}
                </label>
                <input
                  v-model="criterias.orderFileId"
                  placeholder="Numéro de fichier"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>

              <div class="col ">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.orderReference') }}
                </label>
                <input
                  v-model="criterias.orderReference"
                  placeholder="Référence de la commande"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>

              <div class="col ">
                <legend>{{ $t('label.order.details.deliveryAddress') }}</legend>
              </div>
              <div class="col ">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.address') }}
                </label>
                <input
                  v-model="criterias.pinDeliveryAddrLine1"
                  :class="status(v$.criterias.pinDeliveryAddrLine1)"
                  placeholder="Ligne 1"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinDeliveryAddrLine1.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>
              <div class="col">
                <input
                  v-model="criterias.pinDeliveryAddrLine2"
                  placeholder="Ligne 2"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>
              <div class="col">
                <input
                  v-model="criterias.pinDeliveryAddrLine3"
                  :class="status(v$.criterias.pinDeliveryAddrLine3)"
                  placeholder="Ligne 3"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinDeliveryAddrLine3.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>
              <div class="col">
                <input
                  v-model="criterias.pinDeliveryAddrLine4"
                  placeholder="Ligne 4"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>
              <div class="col">
                <input
                  v-model="criterias.pinDeliveryAddrLine5"
                  placeholder="Ligne 5"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>

              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.postalCode') }}
                </label>
                <input
                  v-model="criterias.pinDeliveryAddrZipCode"
                  :class="status(v$.criterias.pinDeliveryAddrZipCode)"
                  placeholder="Code postal"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinDeliveryAddrZipCode.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.city') }}
                </label>
                <input
                  v-model="criterias.pinDeliveryAddrTown"
                  :class="status(v$.criterias.pinDeliveryAddrTown)"
                  placeholder="Ville"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinDeliveryAddrTown.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.countryCode') }}
                </label>
                <input
                  v-model="criterias.pinDeliveryAddrCountryCode"
                  :class="status(v$.criterias.pinDeliveryAddrCountryCode)"
                  placeholder="Code pays"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinDeliveryAddrCountryCode.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.landlinePhoneNumber') }}
                </label>
                <input
                  v-model="criterias.pinDeliveryAddrPhoneNumber"
                  placeholder="Numéro de téléphone fixe"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>

              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.mobilePhoneNumber') }}
                </label>
                <input
                  v-model="criterias.pinDeliveryAddrCellNumber"
                  :class="status(v$.criterias.pinDeliveryAddrCellNumber)"
                  placeholder="Numéro de téléphone portable"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinDeliveryAddrCellNumber.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.email') }}
                </label>
                <input
                  v-model="criterias.pinDeliveryAddrEmail"
                  :class="status(v$.criterias.pinDeliveryAddrEmail)"
                  placeholder="Email"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinDeliveryAddrEmail.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col ">
                <legend>{{ $t('label.order.details.defaultDeliveryAddress') }}</legend>
              </div>
              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.address') }}
                </label>
                <input
                  v-model="criterias.pinNotDeliveredAddrLine1"
                  :class="status(v$.criterias.pinNotDeliveredAddrLine1)"
                  placeholder="Ligne 1"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinNotDeliveredAddrLine1.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>
              <div class="col">
                <input
                  v-model="criterias.pinNotDeliveredAddrLine2"
                  placeholder="Ligne 2"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>
              <div class="col">
                <input
                  v-model="criterias.pinNotDeliveredAddrLine3"
                  :class="status(v$.criterias.pinNotDeliveredAddrLine3)"
                  placeholder="Ligne 3"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinNotDeliveredAddrLine3.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>
              <div class="col">
                <input
                  v-model="criterias.pinNotDeliveredAddrLine4"
                  placeholder="Ligne 4"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>
              <div class="col">
                <input
                  v-model="criterias.pinNotDeliveredAddrLine5"
                  placeholder="Ligne 5"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>

              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.postalCode') }}
                </label>
                <input
                  v-model="criterias.pinNotDeliveredAddrZipCode"
                  :class="status(v$.criterias.pinNotDeliveredAddrZipCode)"
                  placeholder="Code postal"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinNotDeliveredAddrZipCode.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.city') }}
                </label>
                <input
                  v-model="criterias.pinNotDeliveredAddrTown"
                  :class="status(v$.criterias.pinNotDeliveredAddrTown)"
                  placeholder="Ville"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinNotDeliveredAddrTown.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.countryCode') }}
                </label>
                <input
                  v-model="criterias.pinNotDeliveredAddrCountryCode"
                  :class="status(v$.criterias.pinNotDeliveredAddrCountryCode)"
                  placeholder="Code pays"
                  type="text"
                  class="form-control rounded-0"
                >
                <p
                  v-if="validationError"
                  class="error"
                >
                  <span v-if="!v$.criterias.pinNotDeliveredAddrCountryCode.required">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
                </p>
              </div>

              <div class="col">
                <label class="control-label fw-bold mb-1">
                  {{ $t('label.order.details.landlinePhoneNumber') }}
                </label>
                <input
                  v-model="criterias.pinNotDeliveredAddrPhoneNumber"
                  placeholder="Numéro de téléphone fixe"
                  type="text"
                  class="form-control rounded-0"
                >
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              id="closeModal"
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              {{ $t('label.order.details.cancel') }}
            </button>
            <BaseButton
              type="button"
              class="btn btn-primary"
              @click-base-button-event-emitter="remindPin()"
            >
              {{ $t('label.order.details.pinRepublication') }}
            </BaseButton>
          </div>
        </form>
      </div>
    </div>
    <goTopButton />
  </div>
</template>

<script src="./OrderDetail.js"></script>

<style src="./OrderDetail.scss" scoped lang="scss"></style>
